module.exports = __webpack_public_path__ + "img/chi-1-back.29c13969.svg";